module.exports = __webpack_public_path__ + "img/pc-help-1.7864b1bb.jpg";